import React from 'react';
import Item from './components/Item';
import style from './style.css';

const NetworkList = () => {
  const networksBar = window.ExternalConfig.networkNavigation;
  if (!networksBar) return null;
  return (
    <div className={style.container}>
      {networksBar.map(network => (
        <Item {...network} key={`network-list-item-${network.label}`} />
      ))}
    </div>
  );
};

NetworkList.propTypes = {};

NetworkList.defaultProps = {};

export default NetworkList;
